import { RootState } from "@store";
import { notifsClear } from "@store/globalNotifications/actions";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGlobalNotifPosition } from "./position";

export const useGlobalNotifsControl = () => {
  const ref = useRef<HTMLDivElement>(null);
  const pointerRef = useRef({
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
  });

  const gNotifs = useSelector(
    (state: RootState) => state.globalNotifications
  ) || {
    text: "111",
    isLoading: true,
  };
  const timer = gNotifs.timer || 1500;
  const dispatch = useDispatch();

  const updatePosition = () => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const position = getGlobalNotifPosition({
      pointerX: pointerRef.current.x,
      pointerY: pointerRef.current.y,
      width: rect.width,
      height: rect.height,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    });

    ref.current.style.transform = `translate(${position.x}px,${position.y}px)`;
  };

  useEffect(() => {
    const rememberPointer = (e: MouseEvent) => {
      pointerRef.current = {
        x: e.clientX,
        y: e.clientY,
      };
      updatePosition();
    };

    window.addEventListener("mousemove", rememberPointer);
    window.addEventListener("click", rememberPointer);

    return () => {
      window.removeEventListener("mousemove", rememberPointer);
      window.removeEventListener("click", rememberPointer);
    };
  }, []);

  useEffect(() => {
    if (gNotifs.text || gNotifs.isLoading) {
      updatePosition();
    }
  }, [gNotifs.text, gNotifs.isLoading]);

  useEffect(() => {
    const t = setTimeout(() => dispatch(notifsClear()), timer);
    return () => clearTimeout(t);
  }, [gNotifs.text, timer]);

  return {
    ref,
    text: gNotifs.text,
    loading: gNotifs.isLoading,
    timer,

    icon: true,
    isError: gNotifs.isError,
  };
};
